import { useTranslation } from 'react-i18next';
import { DateKeys } from '../../../enums/datekeys';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const DetailsList = ({ data, headers }) => {
    const { t, i18n } = useTranslation();
    //Converts a timestamp into a readable date format to render in the created at
    const formatDate = (timestamp) => {
        if (!timestamp) return '-';
        const date = new Date(timestamp);
        return date.toLocaleDateString(i18n.language, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };
    //Extracts a value from  object
    const extractValueForHeader = (obj, header) => {
        if (!obj || typeof obj !== 'object') return '-';
        return (
            header
                .split('.')
                .reduce((nested, key) => (nested && nested[key] !== undefined ? nested[key] : undefined), obj) ?? '-'
        );
    };
    //Gets the last part of a nested key to use as a label
    const getLabelFromKey = (key) => {
        const parts = key.split('.');
        return parts[parts.length - 1];
    };
    return (
        <ul>
            {headers.map((key) => {
                const extractedValue = extractValueForHeader(data, key);
                const isDateKey = Object.values(DateKeys).includes(key);
                const formattedValue =
                    isDateKey && typeof extractedValue === 'number' ? formatDate(extractedValue) : extractedValue;
                const label = getLabelFromKey(key);
                return (
                    <li key={key}>
                        <span className='label'>{t(label).toUpperCase()}</span>
                        <span className='value'>
                            {formattedValue !== null && formattedValue !== undefined ? formattedValue : '-'}
                        </span>
                    </li>
                );
            })}
        </ul>
    );
};
